import * as React from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import { Theme } from '../models/Theme';

const BadgeWrapper = styled<any, any>('div', 'badgeWrapper', 'badge')`
    ${propStyles};
`;

BadgeWrapper.defaultProps = {
    fontSize: 'xs',
    fontFamily: 'body',
    fontWeight: 'normal',
    textAlign: 'center',
    padding: '0.25em 0.5em',
    minWidth: '2em',
    color: 'white',
    bgColor: 'gray500',
    borderRadius: '3em',
};

interface BadgeProps {
    theme?: Theme;
    selected?: { [property: string]: string | number };
    marginX?: string | number;
}
@observer
class Badge extends React.Component<BadgeProps> {
    render() {
        const { theme, children, ...props } = this.props;
        return (
            <BadgeWrapper {...theme.Badge} {...props}>
                {children}
            </BadgeWrapper>
        );
    }
}

export default withTheme(Badge) as any;



// WEBPACK FOOTER //
// ./src/Components/Badge.tsx